/* istanbul ignore file */
import { LEFT_CLICK } from '../constants'

const simulateMouseEvent = (element, event, x, y) => {
  element.dispatchEvent(
    new MouseEvent(event, {
      view: window,
      bubbles: true,
      cancelable: true,
      clientX: x,
      clientY: y,
      button: 0
    })
  )
}

const getCoordinates = element => {
  const box = element.getBoundingClientRect()

  return {
    x: box.left + (box.right - box.left) / 2,
    y: box.top + (box.bottom - box.top) / 2
  }
}

export const clickElement = (element, events = LEFT_CLICK) => {
  const { x, y } = getCoordinates(element)
  events.forEach(event => simulateMouseEvent(element, event, x, y))
}

export const dispatchKeyboardEvent = (eventType, key, element) => {
  if (!eventType || (!key && key !== '') || !element) {
    console.log('[dispatchKeyboardEvent] missing parameters')
    return
  }
  element.dispatchEvent(new KeyboardEvent(eventType, { key }))
}

export const dispatchDOMEvent = (
  eventType,
  element,
  options = { bubbles: true, cancelable: true }
) => {
  if (!eventType || !element) {
    console.log('[dispatchDOMEvent] missing parameters')
    return
  }
  element.dispatchEvent(new Event(eventType, options))
}

export function preventBubblingEvent(event) {
  event?.preventDefault()
  event?.stopPropagation()
}
